import { useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { DebugPanel } from './debug/DebugPanel'

import { useAuthHook } from '@/hooks/useAuthHook'

interface ProtectedRouteProps {
    children: React.ReactNode
    bypassProtection?: boolean
    isLogin?: boolean
}

const navigationPaths = [
    {
        name: 'initial-inscription',
        path: '/initial-inscription'
    },
    { name: 'Create Account', path: '/createAccount' },
    { name: 'Login', path: '/' },
    { name: 'confirm-email', path: '/confirm-email' },
    { name: 'change-password', path: '/change-password' },
    { name: 'reset-password', path: '/reset-password' }
]

export function ProtectedRoute({
    children,
    bypassProtection = false,
    isLogin = false
}: ProtectedRouteProps): React.ReactElement {
    const { isAuthenticated } = useAuthHook()
    const location = useLocation()
    const isDevelopment = import.meta.env.DEV
    const [bypassAuth, setBypassAuth] = useState(false)

    if (!isAuthenticated && !bypassAuth && !bypassProtection) {
        return (
            <Navigate
                to="/"
                state={{ from: location }}
                replace
            />
        )
    }

    return (
        <>
            {children}
            {isDevelopment && (
                <DebugPanel
                    isLogin={isLogin}
                    navigationPaths={navigationPaths}
                    onBypassChange={setBypassAuth}
                />
            )}
        </>
    )
}
